export default "__VITE_ASSET__DWkURW1J__"